import { computed, defineComponent } from 'vue'
import type { ICountryFlagsProps } from './types'
import Icon from '../icon'
import { getFlagIcon } from '@/data/flag'
import type { IconFactor } from '@/types/elements/icon'

export const CountryFlag = defineComponent<ICountryFlagsProps>(
  (props) => {
    const iconSource = computed((): IconFactor | IconFactor[] => {
      const flag = getFlagIcon(props.country)
      if (flag) {
        return flag
      }
      if (props.iconOptions && props.iconOptions.src) {
        return props.iconOptions.src
      }
      return ''
    })
    return () => {
      return <Icon src={iconSource.value} size={props.iconOptions?.size || '1rem'} />
    }
  },
  { props: ['country', 'iconOptions'] }
)
